export const paramsSerializer = (params: Record<string, unknown>) => {
  const cleanedObject: Record<string, unknown> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      cleanedObject[key] = value;
    }
  });

  return new URLSearchParams(
    cleanedObject as Record<string, string>
  ).toString();
};
